import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import styles from "./CardRows.module.scss"

const CardRows = ({ heading, children }) => {
  const chunk = (input, size) => {
    return input.reduce((arr, item, idx) => {
      return idx % size === 0
        ? [...arr, [item]]
        : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]]
    }, [])
  }

  const rows = chunk(React.Children.toArray(children), 2)

  return (
    <div className={styles.list}>
      {heading && <h2>{heading}</h2>}
      {rows.map((cols, index) => (
        <Row
          className="row-large-gutters bottom-margins mobile-bottom-margins"
          key={index}
        >
          {cols.map((col, index) => (
            <Col md="6" key={index}>
              {col}
            </Col>
          ))}
        </Row>
      ))}
    </div>
  )
}

CardRows.defaultProps = {}

export default CardRows
